import script from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ActiveFilter.vue?vue&type=script&setup=true&lang=js"

import "./ActiveFilter.vue?vue&type=style&index=0&id=6971a6ea&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6971a6ea"]])

export default __exports__